import AddressBookIcon from 'icons/AddressBook.icon';
import { CONTACTS_ROUTE } from 'data/global';
import { COLOR_VARIANT, ColorVariants } from 'models/Colors';
import { IconProp } from 'models/Icon';
import {
  GENERAL_SUGGESTED_ACTION_TYPE,
  GENERAL_SUGGESTION_ACTION,
  GENERAL_SUGGESTION_NAME,
  GeneralSuggestedActionType,
  GeneralSuggestionAction,
  GeneralSuggestionName,
} from 'models/SuggestedActions';

export const GENERAL_SUGGESTION_ICON: Record<
  GeneralSuggestedActionType,
  IconProp
> = {
  [GENERAL_SUGGESTED_ACTION_TYPE.CONTACT_UPLOAD]: AddressBookIcon,
};

export const GENERAL_SUGGESTION_COLOR: Record<
  GeneralSuggestedActionType,
  ColorVariants
> = {
  [GENERAL_SUGGESTED_ACTION_TYPE.CONTACT_UPLOAD]: COLOR_VARIANT.BLUE,
};

export const GENERAL_SUGGESTION_TITLE: Record<
  GeneralSuggestedActionType,
  string
> = {
  [GENERAL_SUGGESTED_ACTION_TYPE.CONTACT_UPLOAD]: 'contactUploadSuggestionTitle',
};

export const GENERAL_SUGGESTION_DESCRIPTION: Record<
  GeneralSuggestedActionType,
  string
> = {
  [GENERAL_SUGGESTED_ACTION_TYPE.CONTACT_UPLOAD]:
    'contactUploadSuggestionDescription',
};

export const GENERAL_SUGGESTION_CTA: Record<
  GeneralSuggestedActionType,
  string
> = {
  [GENERAL_SUGGESTED_ACTION_TYPE.CONTACT_UPLOAD]:
    'contactUploadSuggestionAction',
};

export const GENERAL_SUGGESTION_ROUTE: Record<
  GeneralSuggestedActionType,
  string
> = {
  [GENERAL_SUGGESTED_ACTION_TYPE.CONTACT_UPLOAD]: CONTACTS_ROUTE,
};

export const GENERAL_ACTIONED_NAME: Record<
  GeneralSuggestedActionType,
  GeneralSuggestionName
> = {
  [GENERAL_SUGGESTED_ACTION_TYPE.CONTACT_UPLOAD]:
    GENERAL_SUGGESTION_NAME.CONTACT_UPLOAD,
};

export const GENERAL_ACTIONED_ACTION: Record<
  GeneralSuggestedActionType,
  GeneralSuggestionAction
> = {
  [GENERAL_SUGGESTED_ACTION_TYPE.CONTACT_UPLOAD]:
    GENERAL_SUGGESTION_ACTION.CONTACTS_UPLOADED,
};
